export const onEscPressModalHandler = (evt) => {
  if (evt.key === `Escape`) {
    const modalElements = document.querySelectorAll(`.modal--show`);
    modalElements.forEach((elem) => {
      elem.classList.remove(`modal--show`);
      document.removeEventListener(`keydown`, onEscPressModalHandler);
    });
  }
};
